"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InternalService = void 0;
class InternalService {
    constructor(httpRequest) {
        this.httpRequest = httpRequest;
    }
    /**
     * Get deployment for internal services. This is an efficient endpoint to fetch deployments in a high volume of calls with all its relevant entities without doing external calls.
     * @param id
     * @returns DeploymentTreeResponse
     * @throws ApiError
     */
    getDeploymentInternal(id) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/internal/deployment/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Get current open sponsorships and eligible offers for a channel.
     * @param id
     * @returns DeploymentLightResponse
     * @throws ApiError
     */
    getInternalDeployments(id) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/internal/deployments/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Reindex elasticsearch groups
     * @param requestBody
     * @returns any Successful response
     * @throws ApiError
     */
    reindexGroupsEs(requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/internal/groups/reindex-es',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Reindex elasticsearch group entries
     * @param requestBody
     * @returns any Successful response
     * @throws ApiError
     */
    reindexGroupsEntriesEs(requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/internal/groups/reindex-group-es',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Update active deployments creator id
     * @param creatorId
     * @param requestBody
     * @returns any Successful response
     * @throws ApiError
     */
    updateActiveDeploymentsCreatorId(creatorId, requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/internal/deployments/active/creator/{creatorId}',
            path: {
                'creatorId': creatorId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Reindex elasticsearch deployments
     * @param requestBody
     * @returns any Successful response
     * @throws ApiError
     */
    reindexDeploymentsEs(requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/internal/deployments/reindex-es',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Internal search for sponsorships information
     * @param requestBody
     * @returns SearchResultResponse
     * @throws ApiError
     */
    internalSearch(requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/internal/search',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
exports.InternalService = InternalService;
